import restInitState from '../util/rest/initState';

import {
  SET_CAMS_PRODUCT_DATA,
} from '../actions/types';

const initialState = {
  errors: {},
  data: {},
  actions: [],
  scroll: {},
  condition: {},
};

export default (state = { ...restInitState, ...initialState }, action = {}) => {
  switch (action.type) {
    case SET_CAMS_PRODUCT_DATA:
      return {
        ...state,
        ...action.payload,
      };

    default: return state;
  }
};
